export const initPendo = () => {
  // @ts-expect-error Import works correctly
  import('features/analytics-scripts/scripts/pendo');
};
